import {Component, Input, OnDestroy, OnInit, input} from '@angular/core';
import {ActivatedRoute, Params} from '@angular/router';
import {Store} from '@ngrx/store';
import {Chart} from 'angular-highcharts';
import {Observable, Subscription} from 'rxjs';
import * as fromApp from '../../../store/app.reducers';
import * as fromProfile from '../../store/profile.reducers';
import * as ProfileActions from '../../store/profile.actions';
import * as PostActions from '../../post/store/post.actions';

import {ChartService} from '../../chart.service';
import {Post} from '../../post/post.model';
import {Profile} from '../../profile.model';
import * as DemoActions from '../../../demo/store/demo.actions';
import {HelperService} from '../../../share/helper.service';
import {ToastrService} from 'ngx-toastr';

@Component({
    selector: 'app-followers-demography',
    templateUrl: './followers-demography.component.html',
    styleUrls: ['./followers-demography.component.scss'],
    standalone: false
})
export class FollowersDemographyComponent implements OnInit, OnDestroy {

  readonly type = input<number>(undefined);
  readonly auditType = input<'profile' | 'demo'>(undefined);
  @Input() id: number;
  code: string;
  typeFollower: number;
  typeProgress: string;
  initData: boolean;
  profileState: Observable<fromProfile.State>;
  routeSubscription: Subscription;
  profileSubscription: Subscription;
  chartsAudience: Chart[];
  chartsInterest: Chart[];
  audit: Profile;
  sectionName = {
    gender: '',
    age: '',
    language: '',
    interest: ''
  };

  constructor(
    private store: Store<fromApp.AppState>,
    private route: ActivatedRoute,
    private notifierService: ToastrService,
    private helperService: HelperService
  ) { }

  getAuditType(): 'profile' | 'demo' {
    const auditType = this.auditType();
    if (auditType === undefined) {
      return 'profile';
    }
    return auditType;
  }

  getAuditActions() {
    const auditType = this.auditType();
    if (auditType === undefined || auditType === 'profile') {
      return ProfileActions;
    } else if (auditType === 'demo') {
      return DemoActions;
    }
  }

  ngOnInit() {
    this.sectionName.age = this.helperService.generateRandomString(10);
    this.sectionName.gender = this.helperService.generateRandomString(10);
    this.sectionName.language = this.helperService.generateRandomString(10);
    this.sectionName.interest = this.helperService.generateRandomString(10);

    this.typeFollower = 1;
    this.initData = false;
    if (+this.type() === 1) {
      this.typeProgress = 'follower';
    } else if (+this.type() === 2) {
      this.typeProgress = 'like';
    }
    this.profileState = this.store.select(this.getAuditType());
    this.routeSubscription = this.route.params.subscribe(
      (params: Params) => {
        if (params.id !== undefined) {
          this.id = params.id;
        }
        this.code = params.code;
      }
    );
    this.profileSubscription = this.store.select(this.getAuditType()).subscribe(
      (state: fromProfile.State) => {
        this.audit = state.audit;
        const auditType = this.auditType();
        if (state.audit !== null && state.audit.status !== 0 && !this.initData && auditType === 'profile') {
          this.initData = true;
          if (this.id !== undefined) {
            if (+this.type() === 1) {
              this.store.dispatch(
                new ProfileActions.GetAudienceInterest({
                  id: this.id,
                  type: 1,
                  params: {
                    code: this.code
                  }
                })
              );
            } else if (+this.type() === 2) {

            }

            this.setType(this.typeFollower);
          }
        }

        if (state.audienceStat !== null && (state.chartReload === this.getAuditActions().SET_AUDIENCE_STAT || auditType === 'demo')) {
          this.chartsAudience = [];
          this.chartsAudience.push(
            ChartService.getGenderAudienceChart(state.audienceStat),
            ChartService.getAgeAudienceChart(state.audienceStat),
            ChartService.getLanguageAudienceChart(state.audienceStat)
          );
        }
        if (state.audienceInterest !== null && (state.chartReload === this.getAuditActions().SET_AUDIENCE_INTEREST || auditType === 'demo')) {
          this.chartsInterest = [];
          this.chartsInterest.push(
            ChartService.getInterestAudienceChart(state.audienceInterest.interest)
          );
        }

      }
    );

  }

  setType(type: number) {
    if (this.id !== undefined && this.audit !== null && this.audit.status !== 0) {
      this.typeFollower = type;
      if (+this.type() === 1) {
        this.store.dispatch(
          new ProfileActions.GetAudienceStat({
            id: +this.id,
            type: type,
            params: {
              code: this.code
            }
          })
        );
      } else if (+this.type() === 2) {
        this.store.dispatch(
          new PostActions.GetAudienceStat({
            id: +this.id,
            type: 2
          })
        );
      }
    } else if (this.audit !== null && this.audit.status === 0) {
      this.notifierService.warning('No access in trial account');
    } else {
      this.notifierService.warning('No access in demo audit');
    }

  }

  ngOnDestroy() {
    this.routeSubscription.unsubscribe();
    this.profileSubscription.unsubscribe();
  }

}
